import { AppWindow } from 'lucide-react';

import type { EmbedContent, ScriptElement } from '@/lib/schema.types';

export function EmbedElement({ element, isSelected }: { element: ScriptElement; isSelected: boolean }) {
  const c = element.content as EmbedContent | undefined;
  if (!c?.url) {
    return (
      <div className="flex aspect-video w-full items-center justify-center rounded-md bg-black/5 text-fg-subtle">
        <AppWindow size={20} />
      </div>
    );
  }
  return (
    <iframe
      src={c.url}
      className="block w-full rounded-md"
      style={{ height: c.height ?? 320, pointerEvents: isSelected ? 'auto' : 'none' }}
      sandbox="allow-scripts allow-same-origin"
      title={`embed-${element.id}`}
    />
  );
}
